import {
  batch,
  createCorpHeadersMiddleware as withHeadersMiddleware,
  fetch as fetchBase,
} from '@yandex-delivery/core/utils/network'
import {pipe} from '@yandex-delivery/utils'
import {useMemo} from 'react'

import {useConfigContext} from '../../../contexts/ConfigContext'
import {withCsrfMiddleware} from '../../fetch'

export type FetchFunction = typeof fetchBase

const getAccountRedirectMiddlewareDecorator = (accountUrl: string) =>
  function withAccountRedirectMiddleware(fetchFn: FetchFunction): FetchFunction {
    return function _withAccountRedirectMiddleware(config) {
      return fetchFn(config).catch(error => {
        if (error.status === 410) {
          window.location.href = accountUrl
          return error
        }
        throw error
      })
    }
  }

export const useFetch = () => {
  const {accountUrl, lang, version} = useConfigContext()

  return useMemo<FetchFunction>(
    () =>
      pipe(
        fetchBase,
        // @ts-expect-error<TS2345> - несоответствуют типы middleware
        withCsrfMiddleware,
        getAccountRedirectMiddlewareDecorator(accountUrl),
        withHeadersMiddleware({
          version,
          lang,
          getURI() {
            return `${window.location.origin}${window.location.pathname}`
          },
        }),
        batch,
      ) as FetchFunction,
    [accountUrl, lang, version],
  )
}
